import {
  CacheRulesAction,
  LOAD_CACHE_RULES,
  LOAD_CACHE_RULES_FAIL,
  LOAD_CACHE_RULES_SUCCESS,
  LoadCacheRules,
  LoadCacheRulesFail, LoadCacheRulesSuccess
} from '../actions/cache-rules.action';
import {CacheRules} from "../../websites/website/booster/mappers/cloudflare/cache-rules";

export interface ICacheRulesEntityState {
  entities: {[websiteId: number]: CacheRules};
  loading: boolean;
  loaded: boolean;
}

export interface ICacheRulesState {
  entities: {[websiteId: number]: ICacheRulesEntityState};
}

export const initialState: ICacheRulesState = {
  entities: {}
};


export function reducer(state: ICacheRulesState = initialState, action: CacheRulesAction): ICacheRulesState {
  let payload: any;

  switch (action.type) {

    case LOAD_CACHE_RULES:
      payload = (<LoadCacheRules>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_CACHE_RULES_SUCCESS:
      payload = (<LoadCacheRulesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_CACHE_RULES_FAIL:
      payload = (<LoadCacheRulesFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
